import React from 'react';
import { FormikProps } from 'formik';
import Banner from '@cpg-its/ads.containers.banner';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DomesticPartnerWizard } from '../wizard/domestic-partner-wizard';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { BasicInfo } from '../../personal-info/basic-info';
import { AddressField } from '../../../../../global/components/form-element/address';
import { getAddressLabels } from '../../../selectors/form-selectors';
import { MailingAddressFieldNames } from '../../../models/form-models';
import { DependentMailingAddressRequiredSchema } from '../../dependents/dependent-form-models';
import { PhoneInfo } from '../../personal-info/phone-info';
import { EmailInfo } from '../../personal-info/email-info';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';


interface Props {
	formProps: FormikProps<any>;
	wizard: DomesticPartnerWizard;
	plusSixtyFive?: boolean;
}
export function DomesticPartnerEstablishmentFields(props: Props) {
	const {
		formProps,
		wizard,
		plusSixtyFive,
	} = props;

	const labelSetting = wizard?.getLabelSettings();
	const relationshipsProps = wizard?.getRelationShipSettings();
	return (
		<>
			<DividerSection sectionText={relationshipsProps?.establishDomesticPartnerSectionTitle} >
				<FormGroup>

					<FormField
						name='start_date'
						label={relationshipsProps?.relationshipStartDateLabel}
						component='datePicker'
						touched={formProps.touched}
						errors={formProps.errors}
						required
						autoWidth
					/>
					<FormField
						name='jurisdiction'
						label={relationshipsProps?.jurisdictionLabel}
						component='input'
						errors={formProps.errors}
						touched={formProps.touched}
					/>
					<ContentSpacer>
						<Banner
							banner={{
								type: 'warning',
								label: <WysiwygWithReactLink content={relationshipsProps?.jurisdictionWarningDescription} />,
							}}
						/>
					</ContentSpacer>
				</FormGroup>
			</DividerSection>

			<DividerSection sectionText={relationshipsProps?.dependentInformationSectionLabel}>
				<BasicInfo
					labelSetting={labelSetting}
					formikProps={formProps}
					taxIdOptional
					plusSixtyFive={plusSixtyFive}
				/>
			</DividerSection>

			<DividerSection sectionText={labelSetting?.mailingAddressTitle}>

				<AddressField
					currentCountry={formProps.values.mailing_country === '' ? 'US' : formProps.values.mailing_country}
					labels={getAddressLabels(labelSetting)}
					addressFieldNames={MailingAddressFieldNames}
					requiredSchema={DependentMailingAddressRequiredSchema}
					formProps={formProps}
					person
				/>
			</ DividerSection>

			<PhoneInfo
				labelSetting={labelSetting}
				formProps={formProps}
				hideBusiness
			/>

			<EmailInfo
				labelSetting={labelSetting}
				formProps={formProps}
				hideDescription
				hideBusiness
				removeDivider
			/>			
		</>
	);
}

DomesticPartnerEstablishmentFields.defaultProps = {
	plusSixtyFive: false,
};